"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var lodash_1 = require("lodash");
var react_apollo_1 = require("react-apollo");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
require("./organization-list.scss");
var organization_edit_1 = require("./organization-edit");
var organization_connect_1 = require("./organization-connect");
var AllOrganizations = require("../../core/gql/queries/all-organizations");
var Organizations = require("../../core/gql/queries/organizations");
var OrganizationList = function (_a) {
    var employeeView = _a.employeeView;
    var _b = React.useState(null), connectOrgId = _b[0], setConnectOrgId = _b[1];
    var _c = React.useState(null), selectedOrganizationId = _c[0], setSelectedOrganizationId = _c[1];
    var _d = React.useState(false), showOrgConnectModal = _d[0], setShowOrgConnectModal = _d[1];
    var _e = React.useState(false), showOrgEditModal = _e[0], setShowOrgEditModal = _e[1];
    var showOrganization = function (id) {
        setSelectedOrganizationId(parseInt(id) || null);
        setShowOrgEditModal(true);
    };
    var showConnectToDivision = function (id) {
        setConnectOrgId(parseInt(id) || null);
        setShowOrgConnectModal(true);
    };
    var renderLoading = function () {
        return (React.createElement(teamsnap_ui_1.PanelRow, { mods: "u-textCenter" },
            React.createElement("div", { className: "Loader-indicator" },
                React.createElement("span", { className: "SpinAnimation" }),
                React.createElement("div", { className: "Loader-indicatorText" }, "Loading organizations..."))));
    };
    var renderNoOrgs = function (employeeView) {
        return (React.createElement(teamsnap_ui_1.PanelRow, { mods: "u-textCenter" }, employeeView ? (React.createElement("h4", null,
            "No organizations currently exist.\u00A0\u00A0",
            React.createElement(teamsnap_ui_1.Button, { color: "primary", icon: "plus", iconPosition: "left", onClick: function () { return showOrganization(null); } }, "Create Organization"))) : (React.createElement("h4", null, "You currently do not belong to any organizations."))));
    };
    var renderOrganization = function (organization, employeeView) {
        var _a, _b, _c;
        var ownerEmail = null;
        if (((_a = organization.staff) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            ownerEmail = (_c = (_b = organization.staff) === null || _b === void 0 ? void 0 : _b.find(function (staff) { return staff.roles.map(function (role) { return role.type; }).includes("OWNER"); })) === null || _c === void 0 ? void 0 : _c.emailAddress;
        }
        return (React.createElement(teamsnap_ui_1.PanelRow, { key: "organization-" + organization.id, isWithCells: true },
            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size4of12" }, organization.name),
            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size1of12" }, organization.id),
            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size4of12" }, ownerEmail),
            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size3of12 border-left u-textCenter" },
                React.createElement("div", { className: "button-list" },
                    !employeeView && (React.createElement(react_router_dom_1.Link, { className: "Button Button--small", to: "/organizations/" + organization.id },
                        React.createElement(teamsnap_ui_1.Icon, { name: "home" }),
                        " Go To")),
                    employeeView && [
                        React.createElement(teamsnap_ui_1.Button, { size: "small", icon: "edit", iconPosition: "left", onClick: function () { return showOrganization(organization.id); } }, "Edit"),
                        React.createElement(teamsnap_ui_1.Button, { size: "small", icon: "divisions", iconPosition: "left", onClick: function () { return showConnectToDivision(organization.id); } }, "Connect"),
                    ]))));
    };
    // TODO: is there a cleaner way to break this out?
    var renderOrganizationList = function (employeeView) {
        if (employeeView) {
            return (React.createElement(react_apollo_1.Query, { query: AllOrganizations.QUERY, errorPolicy: "all" }, function (_a) {
                var loading = _a.loading, data = _a.data;
                if (loading)
                    return renderLoading();
                if (data && data.allOrganizations) {
                    if (data.allOrganizations.length > 0) {
                        return (React.createElement(React.Fragment, null, lodash_1.map(lodash_1.sortBy(data.allOrganizations, ["name"]), function (org) { return renderOrganization(org, employeeView); })));
                    }
                    else {
                        return renderNoOrgs(employeeView);
                    }
                }
                else {
                    return React.createElement("div", null);
                }
            }));
        }
        else {
            return (React.createElement(react_apollo_1.Query, { query: Organizations.QUERY, errorPolicy: "all" }, function (_a) {
                var loading = _a.loading, data = _a.data;
                if (loading)
                    return renderLoading();
                if (data && data.organizations) {
                    if (data.organizations.length > 0) {
                        return (React.createElement(React.Fragment, null, lodash_1.map(lodash_1.sortBy(data.organizations, ["name"]), function (org) { return renderOrganization(org, employeeView); })));
                    }
                    else {
                        return renderNoOrgs(employeeView);
                    }
                }
                else {
                    return React.createElement("div", null);
                }
            }));
        }
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "page-content u-xs-padMd u-sm-spaceTopMd u-flexExpandSides" },
            React.createElement("div", { className: "page-content-header Grid u-flexAlignItemsCenter" },
                React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                    React.createElement("h1", null, "Organizations")),
                React.createElement("div", { className: "Grid-cell u-xs-size1of2 u-textRight" }, employeeView && (React.createElement(teamsnap_ui_1.Button, { color: "primary", icon: "plus", iconPosition: "left", onClick: function () { return showOrganization(null); } }, "Create Organization")))),
            React.createElement("div", { className: "page-content-body" },
                React.createElement(teamsnap_ui_1.Panel, { isStriped: true, mods: "Panel--dark-blue" },
                    React.createElement(teamsnap_ui_1.PanelBody, null,
                        React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size4of12 Panel-row--title" }, "Name"),
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size1of12 Panel-row--title" }, "ID"),
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size4of12 Panel-row--title" }, "Email"),
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size3of12 Panel-row--title border-left u-textCenter" }, "Manage")),
                        renderOrganizationList(employeeView)),
                    React.createElement(teamsnap_ui_1.PanelFooter, null,
                        React.createElement("span", null))))),
        showOrgEditModal && React.createElement(organization_edit_1.default, { employeeView: employeeView, setShouldShowModal: setShowOrgEditModal, shouldShowModal: showOrgEditModal, selectedOrganizationId: selectedOrganizationId }),
        employeeView && (showOrgConnectModal && React.createElement(organization_connect_1.default, { setShouldShowModal: setShowOrgConnectModal, shouldShowModal: showOrgConnectModal, organizationId: connectOrgId }))));
};
exports.default = OrganizationList;
//# sourceMappingURL=organization-list.js.map